<app-topnav [pageName]="navPageAccess" [llttfPage]="llttfPage"></app-topnav>
<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="cmha-dashboard">
      <div class="h-30"></div>
      <div class="facility-heading">{{'changePasswordText'|translate:translations}}</div>

      <form #changepasswordform="ngForm">
        <div class="designatedFacilityForm">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{'oldPasswordText'|translate:translations}}</mat-label>
            <input matInput class="form-control-textbox" [(ngModel)]="changePasswordObj.oldPassword" name="oldPassword" type="password" required #oldpassword="ngModel"/>
            @if (oldpassword.invalid && oldpassword.touched) {
              <mat-error>{{'globalFieldRequired'|translate:translations}}</mat-error>
            }
          </mat-form-field>
          <div class="mb-10"></div>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{'newPasswordText'|translate:translations}}</mat-label>
            <input matInput class="form-control-textbox"  [(ngModel)]="changePasswordObj.newPassword" name="newPassword" type="{{revealNewPassword ? 'text' : 'password'}}" required pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{12,}" #newpassword="ngModel"/>
            <button mat-icon-button matSuffix (click)="revealNewPassword = !revealNewPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="revealNewPassword" type="button">
              <mat-icon>{{revealNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            @if (newpassword.invalid && newpassword.touched) {
              <mat-error>
                {{'passwordRequirementsText'|translate:translations}}
              </mat-error>
            }
          </mat-form-field>
          <div class="mb-10"></div>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{'confirmPasswordText'|translate:translations}}</mat-label>
            <input matInput class="form-control-textbox" name="confirmPassword" type="{{revealConfirmPassword ? 'text' : 'password'}}" [(ngModel)]="confirmPassword" required #confirmpassword="ngModel"/>
            <button mat-icon-button matSuffix (click)="revealConfirmPassword = !revealConfirmPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="revealConfirmPassword" type="button">
              <mat-icon>{{revealConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            @if (confirmpassword.invalid && confirmpassword.touched) {
              <mat-error>
                {{'passwordsDoNotMatchText'|translate:translations}}
              </mat-error>
            }
          </mat-form-field>

          <div class="mb-10"></div>
          @if (changePasswordObj.newPassword != confirmPassword) {
            <div><span class="confirm-password-error">{{'passwordsDoNotMatchText'|translate:translations}}</span></div>
          }
          <div class="form-buttons">
            <button type="submit" class="submit-form-button" (click)="changePassword(changepasswordform)">{{'submitButtonText'|translate:translations}}</button>
            <a [routerLink]="cancelLink" class="submit-form-button cancel-button">{{'cancelButtonText'|translate:translations}}</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<app-footer [bbapp]="true"></app-footer>
